import { useEffect, useRef, useState, useMemo } from "react";
import { toast } from "react-toastify";
import StudentLessonChatbot from "../../../../components/studentLessonChatbot/StudentLessonChatbot";
import AnswerInput from "./AnswerInput";
import MCQs from "./MCQs";
import PreprocessAndRenderLatex from "../../../../components/ProcessRenderLatex";
import PreviewPopup from "../../../../components/PreviewPopup/PreviewPopup";
import { useAuth } from "../../../../features/auth/AuthContext";
import { Fab } from "@mui/material";
import MathKeyboardModal from "../../../../components/MathEditor/MathKeyboardModal";
import { marked } from "marked";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { processLatex } from "../../../../utils/PreProcessorLatexCode";
import CustomTooltip from "../../../customtooltip/CustomTooltip";
import { Ring } from "@uiball/loaders";
// import { marked } from "marked";
import Modal from "@mui/material/Modal"; // Using MUI Modal for simplicity
import UploadDocument from "../../../../components/UploadDocument/UploadDocument";
import { useSelector } from "react-redux";
import { normalizeLatexToDoubleDollar } from "../dashboard/teacher/lessons/NewLessons/utils/fileHelpers";
import { formatDictation, endSentence } from "../../../../utils/formatDictation";

const theme = {
  paragraph: "editor-paragraph",
  text: {
    bold: "editor-text-bold",
    italic: "editor-text-italic",
    underline: "editor-text-underline",
  },
};

function Question({
  duration,
  assignment,
  index,
  currentStep,
  handleNext,
  handleSkip,
  handleBack,
  isLast,
  lesson,
  course_id,
  lesson_id,
  assignment_id,
  isTeacher,
  timers,
  setTimers,
  virtualAssistant,
  currentAssignment,
  assignmentType,
  answeredList,
  setAnsweredList,
  courseType,
  assignmentContent,
  skippedQuestions,
  setIsTimerPaused,
  handleMoveNext,
  totalSteps,
  showStudentLessonPreview,
  isVideoBlocked,
  setIsVideoBlocked,
  setIsMathKeyboardOpen,
  isLessonPreviewEnabled
}) {
  const { token } = useAuth();
  const youtubeIframeRef = useRef(null);
  const globalState = useSelector((state) => state.globalState);
  const studentId = globalState.student_details?.data?.student_id;
  const [selectedOption, setSelectedOption] = useState(null);
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [timestamp, setTimestamp] = useState("");

  const [imageUrl, setImageUrl] = useState("");
  const [extractedText, setExtractedText] = useState(null);
  const [openWorkboard, setOpenWorkboard] = useState(false);
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [isRecording, setIsRecording] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isImagePopupOpen, setIsImagePopupOpen] = useState(false);
  const [isFileOperationInProgress, setIsFileOperationInProgress] =
    useState(false);
  const [hasUploadedFiles, setHasUploadedFiles] = useState(false);
  const [isCurrentQuestionAnswered, setIsCurrentQuestionAnswered] =
    useState(false);
  const openImagePopup = () => setIsImagePopupOpen(true);
  const closeImagePopup = () => setIsImagePopupOpen(false);
  const uploadDocumentRef = useRef(null);
  // Answer text from before dictation began; the live transcript is shown after it.
  // null when no dictation is in progress.
  const voiceBaseTextRef = useRef(null);

  // near your other state
  const imageSrc = assignment?.image || assignment?.picture_generation || "";
  const imgRef = useRef(null);
  const [imageStatus, setImageStatus] = useState("idle"); // idle | loading | loaded | error

  // 3. Add handler for audio file save
  const handleAudioSave = (audioFile) => {
    // This will programmatically add the audio file to the upload queue
    if (uploadDocumentRef.current) {
      uploadDocumentRef.current.addFileToQueue(audioFile);
    }
  };




  useEffect(() => {
    if (!imageSrc) {
      setImageStatus("idle");
      return;
    }
    // If the browser already has it cached, onLoad may never fire after mount.
    if (imgRef.current?.complete && imgRef.current.naturalWidth > 0) {
      setImageStatus("loaded");
    } else {
      setImageStatus("loading");
    }
  }, [imageSrc, currentStep]);

  const editorConfig = {
    namespace: "MinimalEditor",
    theme,
    onError: (error) => console.error(error),
  };

  const openKeyboard = () => {
    setIsModalOpen(true);
  };

  const closeKeyboard = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {

    if (currentAssignment?.youtube_url) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(
        currentAssignment.youtube_url,
        "text/html"
      );

      const iframe = doc.querySelector("iframe");

      if (iframe) {
        setYoutubeUrl(iframe.getAttribute("src"));
      }
    } else {
      setYoutubeUrl("");
    }

    if (currentAssignment?.youtube_timestamp) {
      const doc = new DOMParser().parseFromString(
        currentAssignment.youtube_timestamp,
        "text/html"
      );

      const buttonText = doc.querySelector("button")?.textContent || "";
      if (buttonText) {
        setTimestamp(buttonText);
      }
    } else {
      setTimestamp("");
    }

  }, [currentAssignment]);

  useEffect(() => {
    localStorage.setItem("ActiveTab", "Assignments");
    // The parent rebuilds `assignment` every render, so this re-runs constantly.
    // Live dictation isn't persisted until confirm — hydrating now would wipe it
    // and make the answer field blink.
    if (voiceBaseTextRef.current !== null) return;
    if (!isTeacher) {
      const sAPDtls_AssignmentId = localStorage.getItem(
        `sAPDtls_AssignmentId${assignment_id}${token}`,
      );

      if (sAPDtls_AssignmentId && sAPDtls_AssignmentId == assignment_id) {
        const sAProgressDtls =
          JSON.parse(
            localStorage.getItem(
              `studentAssignmentProgressOnSelect${assignment_id}${token}`,
            ),
          ) || [];
        // Every question is mounted at once (only `currentStep` renders), so
        // hydrate each one from its own slot. Reading `currentStep` here handed
        // non-current questions the current answer, which then showed up for one
        // commit when they became visible.
        if (sAProgressDtls[index]) {
          const currentAnswer = sAProgressDtls[index].student_answer;
          if (!assignment.options || assignment.options.length === 0) {
            setSelectedOption(currentAnswer);
          } else {
            if (
              assignment?.type === "MCQ" ||
              assignment?.type === "TF"
            ) {
              const matchingOptionIndex = assignment.options.findIndex(
                (option) => option === currentAnswer,
              );
              setSelectedOption(matchingOptionIndex);
            } else {
              const matchingOptionIndex = currentAnswer ? currentAnswer : null;
              setSelectedOption(matchingOptionIndex);
            }
          }
        } else {
          setSelectedOption(null);
        }
      }
    }
  }, [assignment, index, currentStep, assignment_id, token]);

  const getStoredFiles = (
    assignment_id,
    question_id,
    token,
    practice_assignment_id,
  ) => {
    try {
      const storageKey = practice_assignment_id
        ? `uploaded_files_${assignment_id}_${practice_assignment_id}_${question_id}_${token}`
        : `uploaded_files_${assignment_id}_${question_id}_${token}`;

      const storedFiles = localStorage.getItem(storageKey);

      if (storedFiles) {
        return JSON.parse(storedFiles);
      }
      return [];
    } catch (error) {
      console.error("Error loading files:", error);
      return [];
    }
  };

  // Use useMemo to synchronously compute files BEFORE rendering
  const preloadedFiles = useMemo(() => {
    return getStoredFiles(
      assignmentContent?.assignment_id,
      assignment?.question_id,
      token,
      assignmentContent?.id,
    );
  }, [
    assignmentContent?.assignment_id,
    assignment?.question_id,
    token,
    assignmentContent?.id,
    currentStep,
  ]);

  // Update hasUploadedFiles immediately
  useEffect(() => {
    setHasUploadedFiles(preloadedFiles.length > 0);
  }, [
    preloadedFiles,
    assignmentContent?.assignment_id,
    assignment?.question_id,
    token,
    assignmentContent?.id,
    currentStep,
  ]);

  useEffect(() => {
    if (extractedText) {
      setSelectedOption(extractedText);
      if (!isTeacher) {
        updateLocalStorage(currentStep, extractedText);
      }
    }
  }, [extractedText]);

  const updateLocalStorage = (step, answer) => {
    const sAProgressDtls =
      JSON.parse(
        localStorage.getItem(
          `studentAssignmentProgressOnSelect${assignment_id}${token}`,
        ),
      ) || [];

    while (sAProgressDtls.length <= step) {
      sAProgressDtls.push({});
    }

    sAProgressDtls[step] = { ...sAProgressDtls[step], student_answer: answer };
    localStorage.setItem(
      `studentAssignmentProgressOnSelect${assignment_id}${token}`,
      JSON.stringify(sAProgressDtls),
    );
  };

  const handleOptionChange = (type, value, index = null) => {
    if (type === "MCQ" || type === "TF") {
      setSelectedOption(index);

      const answer = assignment.options ? assignment.options[index] : index;
      if (!isTeacher) {
        updateLocalStorage(currentStep, answer);
      }
    } else {
      setSelectedOption(value);
      if (!isTeacher) {
        updateLocalStorage(currentStep, value);
      }
    }
  };

  // `final` adds a closing full stop; skipped while live so it doesn't flicker mid-speech
  const joinVoiceText = (base, spoken, { final = false } = {}) => {
    const trimmedBase = (base || "").replace(/\s+$/, "");
    // Capitalize only when starting fresh or after a finished sentence
    const capitalizeStart = !trimmedBase || /[.?!]$/.test(trimmedBase);
    let formatted = formatDictation(spoken, { capitalizeStart });
    if (final) formatted = endSentence(formatted);
    if (!formatted) return base || "";
    if (!trimmedBase) return formatted;
    // No space before a leading symbol, e.g. student said "comma" first
    const gap = /^[.,?!;)]/.test(formatted) ? "" : " ";
    return `${trimmedBase}${gap}${formatted}`;
  };

  const handleVoiceStart = () => {
    voiceBaseTextRef.current = typeof selectedOption === "string" ? selectedOption : "";
  };

  // Display-only while speaking; persisted once the student confirms
  const handleVoiceLive = (spoken) => {
    if (voiceBaseTextRef.current === null) return;
    setSelectedOption(joinVoiceText(voiceBaseTextRef.current, spoken));
  };

  const handleVoiceCancel = () => {
    if (voiceBaseTextRef.current === null) return;
    setSelectedOption(voiceBaseTextRef.current);
    voiceBaseTextRef.current = null;
  };

  const handleVoiceText = (text) => {
    // Append to the pre-dictation text, not selectedOption, which already holds the live preview
    const base = voiceBaseTextRef.current ?? (selectedOption || "");
    voiceBaseTextRef.current = null;
    const newText = joinVoiceText(base, text, { final: true });

    setSelectedOption(newText);
    setExtractedText(newText);
    if (!isTeacher) {
      updateLocalStorage(currentStep, newText);
    }
  };

  const handleBackClick = () => {
    const responseData = {
      ...assignment,
      time_taken: timers ? timers[index] : 0,
      student_answer:
        assignment.options?.length > 0
          ? assignment.options[selectedOption]
          : selectedOption,
    };

    handleBack(responseData);
  };

  const handleNextClick = () => {
    if (assignment?.type === "FITB") {
      if (selectedOption) {
        const count = (assignment.question.match(/_+/g) || []).length;
        if (count === 0) {
          const trimmedString = selectedOption.trim();
          const wordsLength = trimmedString
            .split(" ")
            .filter((word) => word !== "")
            .join(" ").length;

          if (150 < wordsLength) {
            toast.error(`No more than 150 characters allowed`);
            return;
          }
        } else {
          const trimmedString = selectedOption.trim();
          const wordsLength = trimmedString
            .split(" ")
            .filter((word) => word !== "")
            .join(" ").length;
          const maxCharacters = 150 * count;

          if (maxCharacters < wordsLength) {
            toast.error(`No more than ${maxCharacters} characters allowed`);
            return;
          }
        }
      }
    }

    if (
      (assignment?.type === "SAQ" || assignment?.type === "EQ") &&
      !isTeacher
    ) {
      const hasAnswer =
        selectedOption &&
        typeof selectedOption === "string" &&
        selectedOption.trim() !== "";

      if (!hasAnswer && !hasUploadedFiles) {
        toast.error(
          "Please provide an answer or upload a file before proceeding.",
        );
        return;
      }
    }

    if (
      assignment?.type !== "SAQ" &&
      assignment?.type !== "EQ" &&
      (selectedOption === -1 ||
        selectedOption === null ||
        selectedOption === undefined ||
        (typeof selectedOption === "string" && selectedOption.trim() === "")) &&
      !isTeacher
    ) {
      if (assignment?.type === "MCQ" || assignment?.type === "TF") {
        toast.error("Please select an option before proceeding.");
      } else {
        toast.error(
          "Before continuing, please ensure the question is answered.",
        );
      }
      return;
    } else {
      if (!isTeacher) {
        if (!timers && !timers[index]) {
          setTimers((prevTimers) => {
            const newTimers = prevTimers ? [...prevTimers] : [];
            newTimers[index] = 0;
            return newTimers;
          });
        }
      }

      const responseData = {
        ...assignment,
        time_taken: timers ? timers[index] : 0,
        student_answer:
          assignment.options?.length > 0
            ? assignment.options[selectedOption]
            : selectedOption,
      };

      handleNext(responseData);
    }
  };

  const isQuestionAnswered = () => {
    try {
      // ONLY check if current question exists in answeredList
      // answeredList is updated ONLY when Next button is clicked
      const isInAnsweredList = answeredList.some(
        (question) => question.question_id === assignment.question_id,
      );

      return isInAnsweredList;
    } catch (error) {
      console.error("Error checking if question is answered:", error);
      return false;
    }
  };

  useEffect(() => {
    const answered = isQuestionAnswered();
    setIsCurrentQuestionAnswered(answered);
  }, [currentStep, answeredList, assignment.question_id]);

  function switchQuestionView() {
    switch (assignment?.type) {
      case "FITB":
        return (
          <AnswerInput
            preventDragDrop={preventDragDrop}
            value={selectedOption || ""}
            onChange={(event) =>
              handleOptionChange(assignment?.type, event?.target?.value)
            }
            index={index}
            assignment_id={assignment_id}
            currentStep={currentStep}
            assignmentType={assignment?.type}
            onMathKeyboardToggle={setIsMathKeyboardOpen} //bb
          />
        );
      case "MCQ":
      case "TF":
        return (
          <MCQs
            options={assignment.options}
            selectedOption={selectedOption}
            setSelectedOption={(index) =>
              handleOptionChange(assignment?.type, null, index)
            }
          />
        );
      default:
        return (
          <AnswerInput
            preventDragDrop={preventDragDrop}
            value={selectedOption || ""}
            onChange={(event) => {
              handleOptionChange(assignment?.type, event?.target?.value);
              setExtractedText(event?.target?.value);
            }}
            index={index}
            assignment_id={assignment_id}
            currentStep={currentStep}
            assignmentType={assignment?.type}
            isRecording={isRecording}
            onMathKeyboardToggle={setIsMathKeyboardOpen} //bb 
          />

          // <MathKeyboardInput
          // value={selectedOption || ""}
          // onChange={(event) => {
          //   handleOptionChange(assignment?.type, event.target.value);
          //   setExtractedText(event.target.value);
          // }} />
        );
    }
  }

  const showWorkboard = () => setOpenWorkboard(true);
  const openPopup = () => setIsPopupVisible(true);
  const closePopup = () => setIsPopupVisible(false);
  const handleCanvaCancel = () => setOpenWorkboard(false);

  async function convertDrawingToText(imageData) {
    try {
      const response = await fetch("https://api.mathpix.com/v3/text", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          app_id: "Webarcitech_621a57", // Replace with your Mathpix app ID
          app_key: "7d36ed55c7649574c24f", // Replace with your Mathpix app key
        },
        body: JSON.stringify({
          src: imageData,
          formats: ["text"],
          math_inline_delimiters: ["$", "$"],
          rm_spaces: true,
        }),
      });
      const data = await response.json();
      setExtractedText(data.text);
      setSelectedOption(data.text || "");
    } catch (error) {
      console.error("Error converting drawing:", error);
      setExtractedText("Error in conversion");
    }
  }






  // "06:37" -> 397 , "1:02:03" -> 3723 , "397" -> 397
  function timestampToSeconds(text) {
    if (!text) return 0;
    const clean = String(text).trim();
    if (/^\d+$/.test(clean)) return parseInt(clean, 10);

    const parts = clean.split(":").map((p) => parseInt(p, 10));
    if (parts.some((p) => Number.isNaN(p))) return 0;

    if (parts.length === 2) return parts[0] * 60 + parts[1];
    if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
    return 0;
  }

  function seekYoutube(iframe, seconds) {
    if (!iframe || !iframe.contentWindow) return false;
    const post = (func, args = []) =>
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: "command", func, args }),
        "https://www.youtube.com"
      );
    try {
      post("seekTo", [seconds, true]);
      post("playVideo");
      return true;
    } catch (e) {
      console.error("seekYoutube postMessage failed:", e);
      return false;
    }
  }



  const youtubeEmbedSrc = useMemo(() => {
    if (!youtubeUrl) return "";
    try {
      const url = new URL(youtubeUrl);
      url.searchParams.set("enablejsapi", "1");
      return url.toString();
    } catch {
      return youtubeUrl; // fallback if it's somehow not a valid URL
    }
  }, [youtubeUrl]);


  const handleTimestampClick = () => {
    const seconds = timestampToSeconds(timestamp);
    const iframe = youtubeIframeRef.current;

    // Preferred: seek without reload via the IFrame API
    const ok = seekYoutube(iframe, seconds);

    // Fallback: if the player isn't ready yet (postMessage ignored on a fresh
    // iframe), reload the src at the timestamp with autoplay. This always works
    // because the click counts as a user gesture.
    if (!ok && iframe) {
      try {
        const url = new URL(iframe.src);
        url.searchParams.set("start", String(seconds));
        url.searchParams.set("autoplay", "1");
        iframe.src = url.toString();
      } catch (e) {
        console.error("timestamp reload fallback failed:", e);
      }
    }

    iframe?.scrollIntoView({ behavior: "smooth", block: "center" });
  };


  const hasRemainingSkippedQuestions =
    skippedQuestions &&
    skippedQuestions.some(
      (isSkipped, idx) => isSkipped === true && idx !== currentStep,
    );

  const totalQuestions =
    skippedQuestions && skippedQuestions.length ? skippedQuestions.length : 0;

  const isCurrentAlreadyAnswered =
    answeredList &&
    answeredList.some((q) => q.question_id === assignment.question_id);

  const currentAnsweredCount =
    answeredList && answeredList.length ? answeredList.length : 0;

  const totalAnsweredAfterClick = isCurrentAlreadyAnswered
    ? currentAnsweredCount
    : currentAnsweredCount + 1;

  const shouldShowSubmitButton =
    !hasRemainingSkippedQuestions && totalAnsweredAfterClick === totalQuestions;

  const preventDragDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const isDisabledNext =
    currentStep === totalSteps - 1 || isFileOperationInProgress;

  const isDisabledSkip =
    isCurrentQuestionAnswered ||
    isFileOperationInProgress ||
    (shouldShowSubmitButton && !hasRemainingSkippedQuestions);

  // const isDimmedSkip =
  //   isCurrentQuestionAnswered || isFileOperationInProgress;

  const isDisabledBack = currentStep === 0 || isFileOperationInProgress;

  const pauseYoutube = () => {
    try {
      youtubeIframeRef.current?.contentWindow?.postMessage(
        JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
        "https://www.youtube.com"
      );
    } catch (e) { /* iframe not ready */ }
  };

  useEffect(() => {
    if (isVideoBlocked) {
      pauseYoutube();
    }
  }, [isVideoBlocked]);


  return currentStep === index ? (
    <>
      {/* {(youtubeUrl !== "" && isLessonPreviewEnabled) && ( */}
      {((youtubeUrl !== "" || assignment?.image || assignment?.picture_generation) && isLessonPreviewEnabled) && (
        <div className="relative flex items-center justify-center my-[20px] [@media(max-height:776px)]:my-[5px]">

          {(youtubeUrl !== "") && (
            <>
              <iframe
                ref={youtubeIframeRef}
                className={`
        w-[500px] h-[280px]
        ${showStudentLessonPreview
                    ? `
            [@media(max-height:865px)_and_(min-height:779px)]:w-[430px]
            [@media(max-height:865px)_and_(min-height:779px)]:h-[210px]
            [@media(max-height:778px)_and_(min-height:707px)]:w-[380px]
            [@media(max-height:778px)_and_(min-height:707px)]:h-[190px]
            [@media(max-height:706px)]:w-[340px]
            [@media(max-height:706px)]:h-[160px]
          `
                    : ""
                  }
      `}
                src={youtubeEmbedSrc}
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              />

              {isVideoBlocked && (
                <div
                  className={`
          absolute inset-0 z-[2] cursor-not-allowed bg-black/35 mx-auto
          w-[500px] h-[280px]
          ${isLessonPreviewEnabled
                      ? `
              [@media(max-height:865px)_and_(min-height:779px)]:w-[430px]
              [@media(max-height:865px)_and_(min-height:779px)]:h-[210px]
              [@media(max-height:778px)_and_(min-height:707px)]:w-[380px]
              [@media(max-height:778px)_and_(min-height:707px)]:h-[190px]
              [@media(max-height:706px)]:w-[340px]
              [@media(max-height:706px)]:h-[160px]
            `
                      : ""
                    }
        `}
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    toast.info("Video can't play while recording.");
                  }}
                />
              )}
            </>
          )}





          {/* {(assignment?.image || assignment?.picture_generation) && (
            <div className="assignment-graph-image w-[420px] cursor-pointer">
              <img
                src={assignment?.image || assignment?.picture_generation}
                alt="img"
                // alt={`Question ${index + 1} Illustration`}
                // style={{ maxWidth: "100%", height: "auto", borderRadius: "8px", marginTop: "8px" }}
                onClick={openImagePopup}
              />
            </div>
          )} */}


          {imageSrc && (
            <div className="assignment-graph-image relative w-[420px] aspect-[4/3] overflow-hidden rounded-lg">
              {imageStatus === "loading" && (
                <div className="absolute inset-0 animate-pulse rounded-lg bg-gray-200" />
              )}

              <img
                ref={imgRef}
                src={imageSrc}
                alt={`Question ${index + 1} illustration`}
                decoding="async"
                fetchPriority="high"
                onLoad={() => setImageStatus("loaded")}
                onError={() => setImageStatus("error")}
                onClick={imageStatus === "loaded" ? openImagePopup : undefined}
                className={`h-full w-full object-contain transition-opacity duration-300
        ${imageStatus === "loaded" ? "opacity-100 cursor-pointer" : "opacity-0"}`}
              />

              {imageStatus === "error" && (
                <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-gray-100 text-sm text-gray-500">
                  Image couldn't be loaded
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div className="AssingmentMCQs-mock-test-question-answer-container">
        <h2>
          <div className="AssingmentMCQs-mock-test-question-folder">
            <span className="AssingmentMCQs-question">Q. {index + 1}:</span>
            <span className="AssingmentMCQs-answers">
              {assignment?.scenario && (
                <div className="assignment-scenario-section">
                  <strong className="text-black text-base font-bold">
                    Context:{" "}
                  </strong>
                  <PreprocessAndRenderLatex
                    content={normalizeLatexToDoubleDollar(assignment.scenario)}
                    isBlockMath={false}
                    latexInline={true}
                  />
                </div>
              )}
              {courseType === 2 ? (
                <PreprocessAndRenderLatex
                  content={normalizeLatexToDoubleDollar(
                    assignmentType === "Mixed"
                      ? `${assignment?.question} (${assignment?.type === "TF" ? "T/F" : assignment?.type})`
                      : assignment?.question,
                  )}
                  isBlockMath={false}
                  latexInline={true}
                />
              ) : (
                <PreprocessAndRenderLatex
                  content={normalizeLatexToDoubleDollar(
                    assignmentType === "Mixed"
                      ? `${assignment?.question} (${assignment?.type === "TF" ? "T/F" : assignment?.type})`
                      : assignment?.question,
                  )}
                  isBlockMath={false}
                  latexInline={true}
                />
              )}

              {(timestamp !== "" && isLessonPreviewEnabled) && (
                // {(timestamp !== "") && (
                <button
                  type="button"
                  className="youtube_timestamp"
                  disabled={isVideoBlocked}
                  style={{ cursor: isVideoBlocked ? "default" : 'pointer' }}
                  onClick={handleTimestampClick}
                >
                  {timestamp}
                </button>
              )}

              {/* {assignmentType === "MIX" && (
                <span>{"(" + assignment?.type + ")"}</span>
              )} */}
            </span>
          </div>
        </h2>
        {switchQuestionView()}

        <div className="assignment-uplode-wrapper">
          {assignment?.type !== "FITB" &&
            assignment?.type !== "TF" &&
            assignment?.type !== "MCQ" && (
              <>
                <UploadDocument
                  ref={uploadDocumentRef} // Pass ref to uploadDocument so we can add files
                  onFileSelect={setImageUrl}
                  // onTextExtract={setExtractedText}
                  assignment_id={assignmentContent?.assignment_id}
                  student_id={studentId}
                  question_id={assignment.question_id}
                  question_type={assignment.type}
                  assignment_type={assignmentType}
                  student_answer_json={assignment}
                  practice_assignment_id={
                    assignmentContent?.id ? assignmentContent?.id : null
                  }
                  onFileOperationChange={setIsFileOperationInProgress}
                  isFileOperationInProgress={isFileOperationInProgress}
                  onFilesChange={setHasUploadedFiles}
                  handleVoiceText={handleVoiceText}
                  handleVoiceStart={handleVoiceStart}
                  handleVoiceLive={handleVoiceLive}
                  handleVoiceCancel={handleVoiceCancel}
                  preloadedFiles={preloadedFiles}
                  setIsTimerPaused={setIsTimerPaused}
                  setIsRecording={setIsRecording}
                  setIsVideoBlocked={setIsVideoBlocked}
                />
              </>
            )}

          {isPopupVisible && (
            <PreviewPopup value={extractedText} onClose={closePopup} />
          )}
        </div>

        <div className="AssingmentMCQs-mock-test-answer-btn-folder">
          {/* LEFT SIDE: Back and Skip buttons */}
          <div className="back-skip-btns">
            {/* BACK BUTTON */}
            <button
              type="button"
              className={`AssingmentMCQs-mock-test-back-btn
                          transition
                          duration-200
                          ${isDisabledBack
                  ? "cursor-not-allowed opacity-60 !text-[#6B7280]"
                  : "cursor-pointer opacity-100 !text-[#0068ff]"
                }
                        `}
              onClick={handleBackClick}
              onFocus={(e) => {
                if (!isDisabledBack) {
                  e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                }
              }}
              onBlur={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
              disabled={isDisabledBack}
            >
              <span className="AssingmentMCQs-mock-test-answer-left-arrow-btn">
                <i className="fa-solid fa-arrow-left"></i>
              </span>
              Back
            </button>
            {/* SKIP BUTTON */}

            {!isTeacher ? <>
              {answeredList?.length === totalSteps ? (
                <button
                  type="button"
                  onClick={handleMoveNext}
                  disabled={isDisabledNext}
                  onFocus={(e) => {
                    e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                  }}
                  className={`AssingmentMCQs-mock-test-skip-btn
                            outline-none
                            transition-[color,box-shadow]
                            duration-200
                            ${isDisabledNext
                      ? "!text-[#6B7280] cursor-not-allowed opacity-60"
                      : "!text-[#0068ff] cursor-pointer"
                    }
                          `}
                >
                  Next <i className="fa-solid fa-arrow-right"></i>
                </button>
              ) : (
                <button
                  type="button"
                  className={`AssingmentMCQs-mock-test-skip-btn
                            outline-none
                            transition
                            duration-200
                            ${isDisabledSkip ? "cursor-not-allowed text-gray-500 opacity-60" : "cursor-pointer text-[#0068ff]"}
                            ${isFileOperationInProgress ? "opacity-60" : ""}
                            `}
                  onClick={handleSkip}
                  disabled={isDisabledSkip}
                  onFocus={(e) => {
                    if (!isDisabledSkip) {
                      e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                    }
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Skip <i className="fa-solid fa-arrow-right"></i>
                </button>
              )}
            </> : <button
              type="button"
              className={`AssingmentMCQs-mock-test-skip-btn
                            outline-none
                            transition
                            duration-200
                            ${isDisabledSkip ? "cursor-not-allowed text-gray-500 opacity-60" : "cursor-pointer text-[#0068ff]"}
                            ${isFileOperationInProgress ? "opacity-60" : ""}
                            `}
              onClick={handleSkip}
              disabled={isDisabledSkip}
              onFocus={(e) => {
                if (!isDisabledSkip) {
                  e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                }
              }}
              onBlur={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Skip <i className="fa-solid fa-arrow-right"></i>
            </button>}
          </div>
          {!isTeacher ? <>
            {answeredList?.length === totalSteps || shouldShowSubmitButton ? (
              // SUBMIT BUTTON - Show when no more skipped questions remain
              !isTeacher ? (
                <button
                  type="button"
                  onClick={handleNextClick}
                  disabled={isFileOperationInProgress}
                  className={`AssingmentMCQs-mock-test-Submit-btn
                            outline-none
                            transition
                            duration-200
                            ${isFileOperationInProgress
                      ? "cursor-not-allowed opacity-60"
                      : "cursor-pointer opacity-100"
                    }
                          `}
                  onFocus={(e) => {
                    if (!isFileOperationInProgress) {
                      e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                    }
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Submit
                  <span className="AssingmentMCQs-mock-test-answer-right-arrow-btn"></span>
                </button>
              ) : (
                ""
              )
            ) : (
              <div className="next-skip-btns">
                <button
                  type="button"
                  onClick={handleNextClick}
                  disabled={isFileOperationInProgress}
                  className={`AssingmentMCQs-mock-test-next-btn
                            outline-none
                            transition
                            duration-200
                            ${isFileOperationInProgress
                      ? "cursor-not-allowed opacity-60"
                      : "cursor-pointer opacity-100"
                    }
                          `}
                  onFocus={(e) => {
                    if (!isFileOperationInProgress) {
                      e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                    }
                  }}
                  onBlur={(e) => {
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Next
                  <span className="AssingmentMCQs-mock-test-answer-right-arrow-btn"></span>
                </button>
              </div>
            )}
          </> : <div className="next-skip-btns">
            <button
              type="button"
              onClick={handleNextClick}
              disabled={isFileOperationInProgress}
              className={`AssingmentMCQs-mock-test-next-btn
                            outline-none
                            transition
                            duration-200
                            ${isFileOperationInProgress
                  ? "cursor-not-allowed opacity-60"
                  : "cursor-pointer opacity-100"
                }
                          `}
              onFocus={(e) => {
                if (!isFileOperationInProgress) {
                  e.currentTarget.style.boxShadow = "0 0 0 3px #0068ff";
                }
              }}
              onBlur={(e) => {
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              Next
              <span className="AssingmentMCQs-mock-test-answer-right-arrow-btn"></span>
            </button>
          </div>}

        </div>
      </div>

      <Modal
        open={isImagePopupOpen}
        onClose={closeImagePopup}
        aria-labelledby="image-popup"
        aria-describedby="popup-showing-full-image"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          outline: "none",
        }}
      >
        <div
          onClick={closeImagePopup}
          className="
                    w-1/2
                    h-1/2
                    outline-none
                    cursor-pointer
                    overflow-hidden
                    flex
                    items-center
                    justify-center
                  "
        >
          <img
            src={assignment?.image || assignment?.picture_generation}
            alt={`Full Question ${index + 1} Illustration`}
            className="w-full h-full object-contain rounded-lg"
          />
        </div>
      </Modal>

      {virtualAssistant && !isTeacher ? (
        lesson ? (
          <StudentLessonChatbot
            ai_name={`${lesson?.teacher?.ai_name}`}
            teacher_id={lesson.teacher?.user_id}
            courseId={course_id}
            lesson_id={lesson_id}
            assignment_id={assignment_id}
            lesson_name={lesson.name ?? ""}
            ai_tone={lesson.teacher?.ai_tone}
            ai_avatar={lesson.teacher?.ai_avatar}
            ai_welcome_msg={lesson.teacher?.ai_welcome_msg}
            page_infojson={assignment}
          />
        ) : null
      ) : null}

      <LexicalComposer initialConfig={editorConfig}>
        <MathKeyboardModal
          isOpen={isModalOpen}
          onClose={closeKeyboard}
          onInsert={() => { }}
        />
      </LexicalComposer>
    </>
  ) : null;
}

export default Question;
